import { render, staticRenderFns } from "./CloseTillSlip.template.vue?vue&type=template&id=311d7ae0&scoped=true&"
var script = {}
import style0 from "./CloseTillSlip.template.vue?vue&type=style&index=0&id=311d7ae0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311d7ae0",
  null
  
)

export default component.exports